

function priorityRank(priority?: string): number {
  const p = (priority || '').toUpperCase();
  if (p === 'URGENT' || p === 'CRITICAL') return 0;
  if (p === 'HIGH') return 1;
  if (p === 'MEDIUM' || p === 'NORMAL') return 2;
  if (p === 'LOW') return 3;
  return 4;
}

export function isUrgentPriority(project: { priority?: string }): boolean {
  const p = (project.priority || '').toUpperCase();
  return p === 'URGENT' || p === 'CRITICAL';
}


export function isSpotlightProject(project: {
  isFeatured?: boolean;
  priority?: string;
}): boolean {
  return !!(project.isFeatured && isUrgentPriority(project));
}


export function sortProjectsByHighlight<T extends {
  isFeatured?: boolean;
  priority?: string;
}>(projects: T[]): T[] {
  return [...projects].sort((a, b) => {
    const aSpot = isSpotlightProject(a) ? 0 : 1;
    const bSpot = isSpotlightProject(b) ? 0 : 1;
    if (aSpot !== bSpot) return aSpot - bSpot;
    const aFeat = a.isFeatured ? 0 : 1;
    const bFeat = b.isFeatured ? 0 : 1;
    if (aFeat !== bFeat) return aFeat - bFeat;
    return priorityRank(a.priority) - priorityRank(b.priority);
  });
}

export function getSpotlightProject<T extends {
  isFeatured?: boolean;
  priority?: string;
}>(projects: T[]): T | null {
  const sorted = sortProjectsByHighlight(projects);
  return sorted.find(isSpotlightProject) ?? sorted.find((p) => p.isFeatured) ?? null;
}
